import localeData from '@wix/locale-dataset-javascript';
import { DEFAULT_TIMEZONE, EVELABLE_LOCALES } from '../constants';
import * as moment from 'moment-timezone';
export var getTimezones = function (locale) {
    locale = locale === 'nb' ? 'no' : locale;
    locale = locale === 'eu' ? 'es' : locale;
    locale = EVELABLE_LOCALES.includes(locale) ? locale : 'en';
    var localeDatasetData = require("@wix/locale-dataset-data/resources/translations/messages_".concat(locale, ".json"));
    var getAllTimezones = localeData.getAllTimezones();
    var timezones = [];
    getAllTimezones.forEach(function (elem) {
        var displayedName = localeDatasetData[elem.displayName];
        if (locale === 'zh') {
            displayedName = displayedName.replaceAll(/：/g, ':');
        }
        var timezoneOption = {
            id: elem.key,
            value: displayedName,
            isSelectable: true,
            label: displayedName,
            timezone: displayedName,
            name: elem.key,
        };
        timezones.push(timezoneOption);
    });
    return timezones;
};
export var getPlaceholder = function (timezone) {
    try {
        var isValideTimezone = isValideTimezonesName(timezone);
        var localeDatasetData = require("@wix/locale-dataset-data/resources/translations/messages_en.json");
        if (isValideTimezone) {
            var getTimezoneByKey = localeData.getTimezoneByKey(timezone);
            if (getTimezoneByKey) {
                var displayName = getTimezoneByKey.displayName;
                var placeholderStr = localeDatasetData[displayName];
                var placeholder = placeholderStr.split(' ')[0];
                return placeholder;
            }
            return getBrowserTimezone(localeDatasetData);
        }
        return getBrowserTimezone(localeDatasetData);
    }
    catch (error) {
        console.error(error);
        return '';
    }
};
export var getBrowserTimezone = function (localeDatasetData) {
    var timezone = browserTimezone();
    var getTimezoneBrowserByKey = localeData.getTimezoneByKey(timezone);
    console.log('[GC] getBrowserTimezone : ', {
        browserTimezone: timezone,
        timezoneByKey: getTimezoneBrowserByKey,
    });
    var displayName = getTimezoneBrowserByKey.displayName;
    console.log('[GC] getBrowserTimezone : ', { displayName: displayName });
    var displayedBrowserName = localeDatasetData[displayName];
    console.log('[GC] getBrowserTimezone : ', { displayedBrowserName: displayedBrowserName });
    return displayedBrowserName.split(' ')[0];
};
export var browserTimezone = function () {
    return Intl.DateTimeFormat().resolvedOptions().timeZone.trim() || DEFAULT_TIMEZONE;
};
export var isValideTimezonesName = function (timezone) {
    var timezones = moment.tz.names();
    return timezones.includes(timezone);
};
//# sourceMappingURL=TimezoneUtils.js.map